import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { motion } from "framer-motion";
import { Spinner } from "reactstrap";
import landinlogo from "assets/images/logo-Landin.svg";
import { ReactComponent as ProfileIcon } from "assets/images/Profile.svg";
import { ReactComponent as MessageIcon } from "assets/images/Message.svg";
import { ReactComponent as LockIcon } from "assets/images/Lock.svg";
import { ReactComponent as GoogleIcon } from "assets/images/new-google.svg";
import { ReactComponent as EditIcon } from "assets/images/edit.svg";
import { ReactComponent as CallIcon } from "assets/images/Call.svg";
import { registerOptions } from "./common/utility";
import Input from "./common/Input";
import ShowError from "./common/ShowError";
import {
  Wrapper,
  Head,
  Titles,
  TitleTexts,
  Steps,
  Step,
  Content,
  NextButton,
  GoogleButton,
  ChangePage,
  Seperator,
  LoginWithButton,
  SendAgain,
  RemainingSendAgain,
  EditWrapper,
} from "./LoginStyles.jsx";
import { useHistory } from "react-router-dom";
import { useMutation } from "react-query";
import {
  getAuthUrlGoogleAuth,
  submitSendOtpCode,
  submitSignIn,
  submitSignInWithGoogle,
} from "api/auth";
import { useDispatch } from "react-redux";
import { signIn as signInAction } from "actions/dashboard";
import { showError, showSuccess } from "utils/ShowToast";
import { ReactComponent as LandinLogo } from "assets/images/logo-Landin.svg";
import OtpAuth from "./OtpAuth";
import { convertAllNumbersToEnglish } from "components/PaymentProduct/utils";

const Signin = ({ withAnim }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  // eslint-disable-next-line unused-imports/no-unused-vars
  const [showGoogle, setShowGoogle] = useState(true);
  const [signupErrors, setSignupErrors] = useState();
  const [otpError, setOtpError] = useState(false);
  const [googleReqisLoading, setGoogleReqisLoading] = useState(false);
  const [googleLoading, setGoogleLoading] = useState(false);
  const [otpCode, setOtpCode] = useState("");
  const [countdown, setCountdown] = useState(0);
  const [canResend, setCanResend] = useState(false);
  const [type, setType] = useState("email");
  const [step, setStep] = useState(1);

  useEffect(() => {
    let timer;
    if (countdown > 0 && !canResend) {
      timer = setInterval(() => {
        setCountdown(prevCount => {
          if (prevCount <= 1) {
            setCanResend(true);
            return 0;
          }
          return prevCount - 1;
        });
      }, 1000);
    }

    return () => clearInterval(timer);
  }, [countdown, canResend]);

  const formatTime = seconds => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    // Convert to Persian numbers
    return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`.replace(
      /[0-9]/g,
      d => "۰۱۲۳۴۵۶۷۸۹"[d]
    );
  };

  const handleChangeOtpCode = code => {
    setOtpError(false);
    setOtpCode(code);
  };

  const signInReq = useMutation(data => submitSignIn(data), {
    onSuccess: res =>
      dispatch(
        signInAction(res.data.body.access_token, res.data.body.refresh_token)
      ),
    // MPCL5: I know this is such a trash error handling but it's just old code that I can't change now!
    onError: err => {
      try {
        if (err.response.data.body) {
          if (err.response.data.body.errors[0].special_code === 346) {
            setOtpError(true);
            setSignupErrors(err.response.data.body.errors);
          } else if (err.response.data.body.errors[0].special_code === 8013) {
            setOtpError(true);
            setSignupErrors(err.response.data.body.errors);
            setCountdown(180); // Reset countdown to 3:00
            setCanResend(false);
          } else {
            setSignupErrors(err.response.data.body.errors);
          }
        } else {
          setSignupErrors([{ message: "مشکل در ارتباط با سرور" }]);
        }
      } catch (err) {
        setSignupErrors([{ message: "مشکل در ارتباط با سرور" }]);
      }
    },
  });

  const getSigninGoogleUrl = async () => {
    setGoogleReqisLoading(true);
    await getAuthUrlGoogleAuth("SignIn")
      .then(res => {
        if (res.data.body.message.authorizationUrl) {
          setGoogleReqisLoading(false);
          setShowGoogle(false);
          window.location.href = res.data.body.message.authorizationUrl;
        }
      })
      .catch(err => {
        console.log(err);
        setGoogleReqisLoading(false);
        setShowGoogle(true);
        showError("مشکل در ارتباط با سرور");
      });
  };

  const otpCodeReq = useMutation(data => submitSendOtpCode(data), {
    onSuccess: res => {
      console.log("otpCodeReq", res);
      setStep(2);
      setCanResend(false);
      setCountdown(180); // Reset countdown to 3:00
    },
    onError: err => {
      try {
        if (err.response.data.body) {
          setSignupErrors(err.response.data.body.errors);
        } else {
          setSignupErrors([{ message: "مشکل در ارتباط با سرور" }]);
        }
      } catch (err) {
        setSignupErrors([{ message: "مشکل در ارتباط با سرور" }]);
      }
    },
  });

  const handleSendOtpCode = async completedCode => {
    setSignupErrors();

    const phone_number = convertAllNumbersToEnglish(getValues("phone_number"));

    if (step === 1) {
      otpCodeReq.mutate({
        phone_number: phone_number,
        page: "signin",
      });
    }

    if (step === 2) {
      const otp_code = completedCode
        ? convertAllNumbersToEnglish(completedCode)
        : convertAllNumbersToEnglish(otpCode);

      signInReq.mutate({
        phone_number: phone_number,
        OTP_code: otp_code,
      });
    }
  };

  const handleSendOtpAgain = () => {
    setSignupErrors();

    const phone_number = convertAllNumbersToEnglish(getValues("phone_number"));

    otpCodeReq.mutate({
      phone_number: phone_number,
    });
  };

  useEffect(() => {
    // if URLSearchParams contained error message, show it
    const error = new URLSearchParams(window.location.search).get("error");
    const code = new URLSearchParams(window.location.search).get("code");

    console.log("error", error);
    console.log("code", code);

    if (code !== null) {
      setGoogleLoading(true);
      submitSignInWithGoogle({ code: code })
        .then(res => {
          if (res.data.body.errors) {
            showError("خطا", res.data.body.errors[0].message);
          } else {
            showSuccess("موفقیت", "شما با موفقیت وارد شدید");
            dispatch(
              signInAction(
                res.data.body.access_token,
                res.data.body.refresh_token
              )
            );
            history.push("/");
            setGoogleLoading(false);
          }
        })
        .catch(err => {
          console.log(err);
          showError("خطا", "مشکل در ارتباط با سرور");
          setGoogleLoading(false);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { register, handleSubmit, errors, formState, getValues } = useForm({
    mode: "onTouched",
  });
  const { touched } = formState;

  const isRequiredError = () => {
    for (const e in errors) {
      if (errors[e].type === "required") {
        return true;
      }
    }
  };

  const isNotRequired = err => {
    if (err.type !== "required") {
      return true;
    }
  };

  const handleSignin = () => {
    signInReq.mutate({
      email_address: getValues("email"),
      password: getValues("password"),
    });
  };

  const handleGotoEditPhoneNumber = () => {
    setSignupErrors();
    setCanResend(false);
    setStep(1);
  };

  const goToOtp = () => {
    setSignupErrors();
    setType("otp");
    setStep(1);
  };

  return (
    <Wrapper>
      {googleLoading ? (
        <div className="popup-loading">
          <div className="text-center">
            <LandinLogo
              className="landin-logo"
              width="200px"
              height="fit-content"
            />
            <div className="loading-wrapper">
              <div className="progress"></div>
            </div>
          </div>
        </div>
      ) : (
        <>
          <Head animate={{ y: 20 }} initial={{ y: withAnim ? 0 : 20 }}>
            <Titles>
              <TitleTexts>
                <div className="main-text">
                  <motion.span
                    animate={{ y: -30 }}
                    initial={{ y: withAnim ? 0 : -30 }}
                  >
                    ثبت نام
                  </motion.span>
                  <motion.span
                    animate={{ y: -30 }}
                    initial={{ y: withAnim ? 0 : -30 }}
                  >
                    {type === "otp" ? "ورود با شماره تماس" : "ورود"}
                  </motion.span>
                </div>
                <motion.div
                  className="light-text"
                  animate={{ opacity: 0 }}
                  initial={{ opacity: withAnim ? 1 : 0 }}
                >
                  مرحله اول
                </motion.div>
              </TitleTexts>
              <a href="https://landin.ir">
                <img src={landinlogo} alt="لوگو" />
              </a>
            </Titles>

            <motion.div
              initial={{
                opacity: 0,
              }}
              animate={{
                opacity: type === "otp" ? 1 : 0,
              }}
              transition={{ type: "spring", duration: 0.5 }}
            >
              <Steps>
                <Step active style={{ marginLeft: 3 }} />
                <Step active={step >= 2} style={{ marginRight: 3 }} />
              </Steps>
            </motion.div>
          </Head>
          <Content style={{ overflow: "unset" }}>
            <form onSubmit={handleSubmit(handleSignin)}>
              {type === "otp" ? (
                <motion.div style={{ display: "flex" }}>
                  <motion.div style={{ width: "100%" }}>
                    <motion.div
                      animate={{
                        opacity: step === 1 ? 1 : 0,
                        height: step === 1 ? "fit-content" : 0,
                      }}
                      transition={{ type: "spring", duration: 0.5 }}
                      style={{ marginTop: step === 1 ? 36 : 0 }}
                    >
                      <Input
                        ref={register(registerOptions.phone_number)}
                        name="phone_number"
                        isFine={
                          getValues("phone_number") &&
                          touched.phone_number &&
                          !errors.phone_number
                        }
                        isError={errors.phone_number}
                        Icon={<CallIcon />}
                        placeholder="شماره تماس"
                        ltr
                        inputMode="numeric"
                        onKeyPress={(e) => {
                          // Allow only Persian digits (۰-۹), English digits (0-9), and + symbol
                          const allowedChars = /[۰-۹0-9+]/;
                          if (!allowedChars.test(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        onChange={(e) => {
                          // Convert Persian digits to English in real-time
                          const convertedValue = convertAllNumbersToEnglish(e.target.value);
                          e.target.value = convertedValue;
                        }}
                      />
                      {errors.phone_number && (
                        <ShowError message={errors.phone_number.message} />
                      )}

                      {signupErrors &&
                        signupErrors.map(e => (
                          <ShowError key={e.message} message={e.message} />
                        ))}
                    </motion.div>

                    <motion.div
                      initial={{
                        opacity: 0,
                        height: 0,
                        y: 0,
                      }}
                      animate={{
                        opacity: step === 2 ? 1 : 0,
                        height: step === 2 ? "fit-content" : 0,
                        y: withAnim ? 0 : 0,
                      }}
                      transition={{ type: "spring", duration: 0.5 }}
                    >
                      <OtpAuth
                        code={otpCode}
                        handleChange={handleChangeOtpCode}
                        numInputs={5}
                        error={otpError}
                        onComplete={completedCode => {
                          handleSendOtpCode(completedCode);
                        }}
                      />
                      <div className="mt-2">
                        {signupErrors &&
                          signupErrors.map(e => (
                            <ShowError key={e.message} message={e.message} />
                          ))}
                      </div>
                    </motion.div>
                  </motion.div>
                </motion.div>
              ) : (
                <motion.div style={{ display: "flex" }}>
                  <motion.div style={{ width: "100%" }}>
                    <motion.div
                      animate={{ y: -20, opacity: 0 }}
                      initial={{ opacity: withAnim ? 1 : 0 }}
                    >
                      <Input
                        name="full_name"
                        Icon={<ProfileIcon />}
                        placeholder="نام و نام خانوادگی"
                      />
                    </motion.div>
                    <motion.div
                      animate={{ y: -40 }}
                      initial={{ y: withAnim ? 0 : -40 }}
                    >
                      <Input
                        ref={register(registerOptions.email)}
                        name="email"
                        isFine={touched.email && !errors.email}
                        isError={errors.email}
                        Icon={<MessageIcon />}
                        placeholder="ایمیل"
                      />
                      <Input
                        ref={register(registerOptions.password)}
                        name="password"
                        isFine={touched.password && !errors.password}
                        isError={errors.password}
                        Icon={<LockIcon />}
                        placeholder="رمز عبور"
                        type="password"
                      />
                      {errors.email && isNotRequired(errors.email) && (
                        <ShowError message={errors.email.message} />
                      )}
                      {errors.password && isNotRequired(errors.password) && (
                        <ShowError message={errors.password.message} />
                      )}
                      {isRequiredError() && (
                        <ShowError message="مقادیر وارد نشده نباید خالی باشد" />
                      )}
                      {signupErrors &&
                        signupErrors.map(e => (
                          <ShowError key={e.message} message={e.message} />
                        ))}
                    </motion.div>
                  </motion.div>
                </motion.div>
              )}

              <motion.div
                animate={{ y: type === "otp" ? 0 : -40 }}
                initial={{
                  y: withAnim
                    ? type === "otp"
                      ? 0
                      : -40
                    : type === "otp"
                    ? -40
                    : 0,
                }}
              >
                {type !== "otp" && (
                  <>
                    <NextButton
                      type="submit"
                      onClick={handleSubmit(handleSignin)}
                      id="GT-signin-button"
                      disabled={signInReq.isLoading}
                    >
                      ورود
                      {signInReq.isLoading && (
                        <Spinner
                          size="sm"
                          style={{ color: "#fff", marginRight: 10 }}
                        />
                      )}
                    </NextButton>
                    <motion.div
                      animate={{ y: 0, opacity: 1 }}
                      initial={{
                        y: withAnim ? 40 : 0,
                        opacity: withAnim ? 0 : 1,
                      }}
                    >
                      <ChangePage style={{ margin: "20px 0" }}>
                        <a href="/auth/forget-password">
                          <div
                            className="light-text"
                            style={{ cursor: "pointer", fontWeight: 300 }}
                            id="GT-resetpassword"
                          >
                            رمز عبور خود را فراموش کردم!
                          </div>
                        </a>
                      </ChangePage>
                    </motion.div>
                    <motion.div
                      animate={{ y: 0 }}
                      initial={{ y: withAnim ? -30 : 0 }}
                    >
                      <Seperator style={{ margin: "20px 0" }}>
                        <div className="line" />
                        <div className="text">یا</div>
                        <div className="line" />
                      </Seperator>
                      <LoginWithButton onClick={goToOtp}>
                        ورود با شماره تماس
                      </LoginWithButton>
                      {showGoogle && (
                        <>
                          <GoogleButton onClick={getSigninGoogleUrl}>
                            ورود با گوگل
                            {googleReqisLoading ? (
                              <Spinner
                                size="sm"
                                style={{ color: "#7E77EB", marginRight: 10 }}
                              />
                            ) : (
                              <GoogleIcon />
                            )}
                          </GoogleButton>
                        </>
                      )}
                      <ChangePage style={{ marginTop: 30 }}>
                        <div className="light-text">
                          <motion.div animate={{ display: "none", opacity: 0 }}>
                            از قبل حساب کاربری دارید؟
                          </motion.div>
                          <motion.div animate={{ opacity: 1 }}>
                            هنوز عضو نشده‌اید؟
                          </motion.div>
                        </div>
                        <div className="link-text">
                          {/* <motion.div animate={{ display: "none", opacity: 0 }}>
                    ورود به حساب کاربری
                  </motion.div> */}
                          {/* <Link href="/auth/SignIn"> */}
                          <motion.div
                            animate={{ opacity: 1 }}
                            onClick={() => history.push("/auth/SignUp")}
                          >
                            ثبت نام کنید
                          </motion.div>
                          {/* </Link> */}
                        </div>
                      </ChangePage>
                    </motion.div>
                  </>
                )}
                {type === "otp" && (
                  <motion.div
                    animate={{ y: 0 }}
                    initial={{ y: withAnim ? 0 : -30 }}
                  >
                    <NextButton
                      type="submit"
                      onClick={handleSubmit(handleSendOtpCode)}
                      id={"GT-signin-button-2"}
                      disabled={
                        (step === 1 && otpCodeReq.isLoading) ||
                        signInReq.isLoading
                      }
                    >
                      {step === 1 ? "ارسال کد" : "تایید کد"}
                      {(otpCodeReq.isLoading || signInReq.isLoading) && (
                        <Spinner
                          size="sm"
                          style={{ color: "#fff", marginRight: 10 }}
                        />
                      )}
                    </NextButton>

                    {step === 2 && (
                      <>
                        {canResend ? (
                          <SendAgain onClick={handleSendOtpAgain}>
                            ارسال مجدد
                          </SendAgain>
                        ) : (
                          <RemainingSendAgain>
                            ارسال مجدد کد <span>{formatTime(countdown)}</span>{" "}
                            دیگر
                          </RemainingSendAgain>
                        )}
                        <EditWrapper onClick={handleGotoEditPhoneNumber}>
                          <EditIcon className="mt-1" />
                          <p className="mb-0 pb-0">ویرایش شماره</p>
                        </EditWrapper>
                      </>
                    )}

                    <ChangePage style={{ marginTop: 30 }}>
                      <div className="light-text">
                        <motion.div animate={{ display: "none", opacity: 0 }}>
                          از قبل حساب کاربری دارید؟
                        </motion.div>
                        <motion.div animate={{ opacity: 1 }}>
                          هنوز عضو نشده‌اید؟
                        </motion.div>
                      </div>
                      <div className="link-text">
                        {/* <motion.div animate={{ display: "none", opacity: 0 }}>
                    ورود به حساب کاربری
                  </motion.div> */}
                        {/* <Link href="/auth/SignIn"> */}
                        <motion.div
                          animate={{ opacity: 1 }}
                          onClick={() => history.push("/auth/SignUp")}
                        >
                          ثبت نام کنید
                        </motion.div>
                        {/* </Link> */}
                      </div>
                    </ChangePage>
                  </motion.div>
                )}
              </motion.div>
            </form>
          </Content>
        </>
      )}
    </Wrapper>
  );
};

export default Signin;
